<template>
    <div>
        <LsNavbar v-if="!loading && me.is_admin" :user="me" />
        <div v-if="!loading && me.is_admin" class="container">
            <RouterView />
        </div>
    </div>
</template>

<script>
import { lsErrorService } from 'ls-vue-common';
import LsNavbar from '@/components/LsNavbar/LsNavbar.vue';
import Me from '@/graphql/queries/Me.gql';

export default {
    name: 'AuthorizedParentView',
    components: {
        LsNavbar,
    },
    data() {
        return {
            me: null,
            loading: 0,
        };
    },
    apollo: {
        me: {
            query: Me,
            error(error) {
                lsErrorService.log({ error, showAlert: true });
                this.$apollo.queries.me.skip = false;
            },
            result({ data, loading }) {
                if (!loading) {
                    this.me = data.me;
                }
            },
            fetchPolicy: 'cache-and-network',
            loadingKey: 'loading',
        },
    },
};
</script>

<style lang="scss" scoped>
/* override main.scss container media queries so content is always below navbar */
.container {
    padding-top: $navbar-height + 2rem;
    margin-bottom: 35px;
}
</style>
